import React from 'react'
import { Box, Paper, Text } from '@mantine/core'

interface OrdersHeaderProps {
  totalCount: number
}

export default function OrdersHeader({ totalCount }: OrdersHeaderProps) {
  return (
    <Paper
      p="xl"
      radius="lg"
      style={{
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        marginBottom: '20px',
      }}
    >
      <Box>
        <Text size="24px" fw={700} style={{ color: '#1e3a8a', marginBottom: '8px' }}>
          我的风险评估报告
        </Text>
        <Text size="sm" c="dimmed">
          {totalCount > 0 ? `共 ${totalCount} 条记录` : '暂无报告记录'}
        </Text>
      </Box>
    </Paper>
  )
}
